import { memo } from 'react';
import { Box, Text } from '@rsos/base-components';

const CallTakerModeTooltip = memo(({ callTakerModeSettings }) => (
  <Box data-name="call-taker-mode-tooltip">
    {callTakerModeSettings?.is_enabled ? (
      <>
        <Text>Call Taker Mode: On</Text>
        <Text>{`Seat Position: ${callTakerModeSettings?.workstation_position}`}</Text>
      </>
    ) : (
      'Call Taker Mode: Off'
    )}
  </Box>
));

export default CallTakerModeTooltip;
